import Vue from 'vue'
import axios from 'axios'
import { apiUrl } from '@/api/apiUrl'
import {
  _
} from 'underscore'

const state = {
  processing: []
}

const mutations = {
  FETCH_PROCESSING(state, items) {
    state.processing = items
  }
}

const actions = {
  getProcessing({
    commit
  }) {
    return new Promise((resolve, reject) => {
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(apiUrl + "processing", {}, config)
        .then(({
          data
        }) => {
          if (data.state_id == 0 && data.total > 0) {
            commit('FETCH_PROCESSING', data.list)
            resolve()
          }
        })
        .catch(err => {
          reject(err)
        });
    })
  }
}
const getters = {
  processingList(state) {
    return state.processing.sort((a, b) => {
      if (a.human_name > b.human_name) return 1
      if (a.human_name < b.human_name) return -1
      return 0
    })
  },
  processingName: state => id => {
    if (state.processing && state.processing.length > 0 && id != null) {
      let item = _.find(state.processing, el => el.id == id)
      if (item != undefined) return item['human_name']
      else return ""
    } else {
      return ""
    }
  },
  processingIcon: state => id => {
    if (state.processing && state.processing.length > 0 && id != null) {
      let item = state.processing.find(el => el.id == id)
      if (item != undefined) return item['icon_url']
      else return ""
    } else {
      return ""
    }
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}